<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="roleManagementData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="delete"></template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除账户模式框 -->
    <Modal v-model="roleManagementDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ roleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRoleManagement()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-role-management
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-role-management>
  </div>
</template>
<script>
import AddOrUpdateRoleManagement from "../role_management/AddOrUpdateRoleManagement";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

let tableRoleManagementVue = {};
export default {
  components: {
    ConfigurationManagementOperationLog,
    AddOrUpdateRoleManagement
  },
  name: "TableRoleManagement",
  data() {
    return {
      isShowOperationLog: false,
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      roleManagementDelmodal: false,
      roleName: "",
      modal_loading: false,
      isDisable: false,
      addOrUpdateVisible: false, //添加&编辑
      columns: [
        {
          title: this.$t(
            "permission_configuration_management.role.companyName"
          ),
          key: "companyName"
        },
        {
          title: this.$t("permission_configuration_management.role.roleName"),
          key: "roleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "status",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 false,1 true
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.status == true // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.common.enable"
                      )
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.common.disable"
                      )
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("common.note"),
          key: "remark"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.logClick(params.row);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:roleManagement:log"
                      )
                    }
                  ]
                },
                this.$t(
                  "permission_configuration_management.common.operationLog"
                )
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.addOrUpdateHandle(
                        params.row.roleId,
                        params.row.companyName
                      );
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:roleManagement:edit"
                      )
                    }
                  ]
                },
                this.$t("permission_configuration_management.common.edit")
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: params.row.flag === true
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.roleManagementDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:roleManagement:delete"
                      )
                    }
                  ]
                },
                this.$t("permission_configuration_management.common.delete")
              )
            ]);
          }
        }
      ],
      roleManagementData: [],
      menuData: [],
      menuIdData: [],
      subdata: []
    };
  },
  beforeCreate: function() {
    tableRoleManagementVue = this;
  },
  mounted: function() {
    tableRoleManagementVue.getRoleManagementData();
  },
  methods: {
    showAll: function() {
      tableRoleManagementVue.getRoleManagementData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.roleName = this.roleManagementData[index].roleName;
    },
    // 分页显示数据
    getRoleManagementData: function() {
      // 获取查询里面的搜索内容
      eventBus.$on("roleManagementSearchName", function(val) {
        tableRoleManagementVue.val = val;
      });
      eventBus.$on("companyId", function(val) {
        tableRoleManagementVue.companyId = val;
      });
      //账户列表分页
      this.$api.security
        .pageRole({
          roleName: tableRoleManagementVue.val,
          companyId: tableRoleManagementVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.roleManagementData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRoleManagementVue.getRoleManagementData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRoleManagementVue.getRoleManagementData();
    },
    // 删除
    removeRoleManagement: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.security
        .deleteRole("roleId", this.roleManagementData[lineIndex].roleId)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableRoleManagementVue.getRoleManagementData();
            this.isDisable = false;
            this.modal_loading = false;
            this.roleManagementDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 销毁roleManagementSearchName
    beforeDestroy: function() {
      eventBus.$off("roleManagementSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0停用 1正常
      if (this.roleManagementData[index].status == true) {
        this.changeStatusMessage(
          this.roleManagementData[index].roleId,
          "status",
          0
        );
      } else {
        this.changeStatusMessage(
          this.roleManagementData[index].roleId,
          "status",
          1
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.security
        .changeStatus({
          roleId: id,
          status: value
        })
        .then(res => {
          tableRoleManagementVue.getRoleManagementData();
        });
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.roleId,
          9
        );
      });
    },
    //编辑
    /****************************************************/
    addOrUpdateHandle: function(id, companyName) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$router.push({
          path: "/permissionsConfigurationManagement/addOrUpdateRoleManagement",
          query: { id: id, companyName: companyName }
        });
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/role_management/TableRoleManagement.vue